import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  location: 'Rosario'
}, {
  name: 'Javier P.',
  location: 'Córdoba'
}, {
  name: 'Alejandro R.',
  location: 'Buenos Aires'
}, {
  name: 'Marcelo D.',
  location: 'Mendoza'
}, {
  name: 'Gustavo F.',
  location: 'Tucumán'
}, {
  name: 'Daniel S.',
  location: 'Neuquén'
}, {
  name: 'Pablo L.',
  location: 'Mar del Plata'
}, {
  name: 'Fernando G.',
  location: 'Salta'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[280px] md:max-w-[320px]" data-id="element-297">
      <div className="bg-brand-card rounded-xl shadow-[0_0_20px_rgba(34,197,94,0.3)] border-2 border-brand-accent p-4 flex items-start gap-3 relative overflow-hidden" data-id="element-298">
        <div className="bg-brand-accent/20 p-2 rounded-full shrink-0" data-id="element-299">
          <CheckCircle className="w-6 h-6 text-brand-accent" data-id="element-300" />
        </div>
        <div data-id="element-301">
          <p className="text-sm md:text-base text-gray-200 font-medium leading-tight mb-1" data-id="element-302">
            <span className="font-black text-white" data-id="element-303">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Digital 💻
          </p>
          <p className="text-xs text-brand-accent font-black uppercase tracking-wide" data-id="element-304">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-305">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}